import React, { useEffect, useState } from 'react'
import validityAdminServices from '../validityAdminServices'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import moment from 'moment';
import { useAlert } from '../../../context/AlertContext';

function ValideTillComponent({portal,manualDate=true}) {

    const {AppAlert} = useAlert();

    const [validityDate,setValidityDate] = useState(null) 
    const [diff,setDiff] = useState(0);
    const [dialogStatus, setDialogStatus] = useState(false);

    const [otpSent,setOtpSent] = useState(false);
    const [newDate,setNewDate] = useState("");
    const [otp,setOtp] = useState("");


    const getValidity = () => {
        validityAdminServices.getValidity(portal).then(res=>{
          //console.log(res.data);  
          setValidityDate(res.data);
          let _diff = moment(res.data).unix() - moment().unix();
          setDiff(_diff);
          //AppAlert()
        }).catch(error=>{
            console.log(error)
            AppAlert(error.msg,"error");
        })
    }



    const requestOtp = () =>{
        validityAdminServices.validityRequestOtp(portal).then(res=>{
            //console.log(res);
            AppAlert(res.msg)
            setOtpSent(true);
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        })
    }


    const updateValidation = () =>{
        let payload = {
            otp:otp,
            newDate:newDate
        }

        validityAdminServices.validityUpdate(portal,payload).then(res=>{
            console.log(res);
            AppAlert(res.msg)
            getValidity();
            setDialogStatus(false);
        }).catch(error=>{
            console.log("error is ",error);
            AppAlert(error.msg,"error");
        })
    }

    useEffect(()=>{
        if(!manualDate){
            getValidity();
        }
    },[manualDate])
    

    

    return (
        <>
            {validityDate ? 
                <>
                    <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(true)} >{validityDate} </button>
                    { diff < 0 && <span className='text-danger ms-2'>Expired</span>}
                    { diff > 0 && diff < 15*86400  && <span className='text-danger bg-warning p-2 rounded ms-2'>Expiring Soon {moment(validityDate).format("LL")} </span>}
                    <Dialog
                        open={dialogStatus}
                        keepMounted
                        onClose={()=>setDialogStatus(false)}
                        maxWidth="md"
                    >

                        <DialogTitle className='bg-danger text-white mb-3'>
                            Update Validity for {portal.portalId} ( {portal.title} )
                        </DialogTitle>

                        {!otpSent &&
                            <DialogContent>
                                <div className='text-center'>
                                    <button className='btn btn-danger' onClick={requestOtp} >Request OTP</button>
                                </div>
                            </DialogContent>
                        }

                        {otpSent &&
                            <DialogContent>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <h6 className='fw-bold'>Expire Date :  <span className='text-success'>{moment(validityDate).format("LL")}</span></h6>
                                    </div>
                                    <div className='col-md-12'>
                                        <div class="input-group mb-3">
                                            <span class="input-group-text" id="basic-addon1">New Date</span>
                                           <input className='form-control' type='date' value={newDate} onChange={(e)=>setNewDate(e.target.value)} />
                                        </div>

                                        <div class="input-group">
                                            <span class="input-group-text" id="basic-addon1">OTP</span>
                                           <input className='form-control' type='number' value={otp} onChange={(e)=>setOtp(e.target.value)} />
                                        </div>
                                        
                                    </div>
                                </div>
                            </DialogContent>
                        }

                        {otpSent &&
                            <DialogActions>
                                <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)} >Close</button>
                                <button disabled={otp==="" || newDate ===""}  className='btn btn-primary' onClick={updateValidation} >Submit</button>
                            </DialogActions>
                        }

                        

                    </Dialog>
                </>

                

                :
                <button className='btn btn-outline-primary' onClick={()=>getValidity()} >Get Details </button>
            }
            

        </>
    )
}

export default ValideTillComponent